import React from "react";
import "./Skills.css";
import { skillGroups } from "../data/portfolioData";
import {
  HiCode,
  HiServer,
  HiDatabase,
  HiChartSquareBar,
  HiCloud,
  HiColorSwatch,
  HiLightningBolt,
} from "react-icons/hi";

function Skills() {
  const getCategoryIcon = (category) => {
    switch (category) {
      case "Languages":
        return <HiCode size={20} />;
      case "Backend":
        return <HiServer size={20} />;
      case "Data and Messaging":
        return <HiDatabase size={20} />;
      case "Observability":
        return <HiChartSquareBar size={20} />;
      case "DevOps":
        return <HiCloud size={20} />;
      case "Frontend":
        return <HiColorSwatch size={20} />;
      case "AI":
        return <HiLightningBolt size={20} />;
      default:
        return <HiCode size={20} />;
    }
  };

  return (
    <section id="skills" className="skills-section section">
      <div className="container">
        <div className="section-header">
          <span className="section-eyebrow">Expertise</span>
          <h2 className="section-title">Technical Skills</h2>
          <p className="section-subtitle">
            Core technologies, backend frameworks, data stores, and infrastructure tools utilized in production.
          </p>
        </div>

        <div className="skills-categories-grid">
          {skillGroups.map((group, index) => (
            <div key={index} className="skill-group-card">
              <div className="group-header">
                <span className="group-icon">{getCategoryIcon(group.category)}</span>
                <h3 className="group-title">{group.category}</h3>
              </div>

              <div className="group-pills">
                {group.skills.map((skill, sIdx) => (
                  <span key={sIdx} className="skill-pill">
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
